<script lang="ts" src="./Toast.ts"></script>


<template>

  <div></div>

</template>


<style lang="scss" scoped>
</style>
